import { useEffect, useState } from 'react';
import { api, type Campagne } from './api';
import type { Preset } from './format';

export interface EtatFiltres { campagne: number | null; preset: Preset; du: string; au: string }

export function Filtres({ valeur, surChangement, note }: { valeur: EtatFiltres; surChangement: (v: EtatFiltres) => void; note?: string }) {
  const [campagnes, setCampagnes] = useState<Campagne[]>([]);
  useEffect(() => {
    api.campagnes().then((r) => setCampagnes(r.campagnes)).catch(() => setCampagnes([]));
  }, []);
  const maj = (p: Partial<EtatFiltres>) => surChangement({ ...valeur, ...p });
  return (
    <form className="filtres" aria-label="Filtres" onSubmit={(e) => e.preventDefault()}>
      <label className="filtre-campagne">
        <span>Campagne</span>
        <select value={valeur.campagne ?? ''} onChange={(e) => maj({ campagne: e.target.value ? Number(e.target.value) : null })} data-testid="filtre-campagne">
          <option value="">Toutes les campagnes</option>
          {campagnes.map((c) => <option key={c.id} value={c.id}>{c.nom}{c.statut ? ` (${c.statut})` : ''}</option>)}
        </select>
      </label>
      <label>
        <span>Période</span>
        <select value={valeur.preset} onChange={(e) => maj({ preset: e.target.value as Preset })} data-testid="filtre-periode">
          <option value="tout">Depuis le début</option>
          <option value="7j">7 derniers jours</option>
          <option value="30j">30 derniers jours</option>
          <option value="perso">Dates choisies</option>
        </select>
      </label>
      {valeur.preset === 'perso' && (
        <>
          <label><span>Du</span><input type="date" value={valeur.du} max={valeur.au || undefined} onChange={(e) => maj({ du: e.target.value })} /></label>
          <label><span>Au</span><input type="date" value={valeur.au} min={valeur.du || undefined} onChange={(e) => maj({ au: e.target.value })} /></label>
        </>
      )}
      {note && <p className="note">{note}</p>}
    </form>
  );
}
